import React from 'react';
import { Button } from '@prosolve/common-components-ui'
import { FaFilePdf } from 'react-icons/fa';

export default ({
  sessionData = {}
}) => {

  const {
    blueprintLink = '',
    slideDeckLink = '',
    slideDeckLinkOverride = '',
    hideSlideDeckLink,
  } = sessionData;

  const hasSlideDeckLink = (Boolean(slideDeckLink) || Boolean(slideDeckLinkOverride))

  const openBlueprintInNewTab = () => {
    window.open(blueprintLink, "Session Blueprint")
  }

  const openSlideDeckInNewTab = () => {
    window.open(slideDeckLinkOverride || slideDeckLink, "Session Blueprint")
  }

  return (
    <div
      style={{
        padding: '0px 20px 20px 7px' // '20px'
      }}
    >
      <Button
        style={{
          display: 'inline-flex',
          border: 'none',
          position: 'relative',
          marginRight: '10px'
        }}
        onClick={Boolean(blueprintLink) ? openBlueprintInNewTab : undefined}
      >
        {Boolean(blueprintLink) 
        ?
        <>
          <span style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{'Open Document In New Tab'}</span>
          <FaFilePdf style={{ marginLeft: '10px', color: '#0280c6', fontSize: '18px' }} />
        </>
        :
        <span style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{'No Facilitation Guide Document is available'}</span>
      }
      </Button>
      {
        !hideSlideDeckLink &&
        <Button
          style={{
            display: 'inline-flex',
            border: 'none',
            position: 'relative',
          }}
          onClick={hasSlideDeckLink ? openSlideDeckInNewTab : undefined}
        >
          {hasSlideDeckLink
            ?
            <>
              <span style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{'Open Slide Deck in New Tab'}</span>
              <FaFilePdf style={{ marginLeft: '10px', color: '#0280c6', fontSize: '18px' }} />
            </>
            :
            <span style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{'No Slide Deck is available'}</span>
          }
        </Button>
      }
    </div>
  )
}